import type { FC } from 'react'
import { useShallow } from 'zustand/react/shallow'
import useSpeechDialogStore from './speech-dialog.store.ts'
import { SpeechContentType } from './types.ts'
import SpeechDialogMain from './SpeechDialogMain'
import SpeechDialogLibrary from './SpeechDialogLibrary'
import SpeechDialogVoices from './SpeechDialogVoices'
import Dialog from '@/components/common/Dialog'
import useUiStore from '@/shared/store/ui.store.tsx'
import useAudioStore from '@/shared/store/audio.store.tsx'

const SpeechDialog: FC = () => {
  const { contentType, reset, stopRecorderFn } = useSpeechDialogStore()
  const setSpeechDialogOpen = useUiStore(
    useShallow(({ setSpeechDialogOpen }) => setSpeechDialogOpen)
  )
  // Check if the Generate button should be disabled
  const stopPlayback = useAudioStore(
    useShallow(({ stopPlayback }) => stopPlayback)
  )
  const onDialogClose = () => {
    stopRecorderFn()
    stopPlayback()
    reset()
    setSpeechDialogOpen(false)
  }
  const views: Record<SpeechContentType, FC<{ onClose: () => void }>> = {
    [SpeechContentType.Main]: SpeechDialogMain,
    [SpeechContentType.Library]: SpeechDialogLibrary,
    [SpeechContentType.Voices]: SpeechDialogVoices,
  }
  const InnerView = views[contentType]

  return (
    <Dialog open={true} onClose={onDialogClose}>
      <InnerView onClose={onDialogClose} />
    </Dialog>
  )
}

export default SpeechDialog
